import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FacetDropdown } from '../FacetDropdown';

const AgeRange = ({ ageRange, ageRangeFromQS, afterChangedValue, min, max, history: { push }, base, searchType, isMobile }) => {
  const options = [...Array(20)].map((v, i) => ({ value: `${i}`, label: `${i} year${i === 1 ? '' : 's'}` }));
  const isSupply = searchType === 'supply';
  const minValues = options.slice(0, ageRange[1] + 1);
  const maxValues = options.slice(ageRange[0]);
  const selectedMinValue = (ageRange[0] === 0) ? '' : '' + ageRange[0];
  const selectedMaxValue = (ageRange[1] === 19) ? '' : '' + ageRange[1];
  return (<div className="age-range">
    { !isSupply && <label className="col-md-6 padding-right-none col-xs-12 dropdown-label">Ages taught</label> }
    <div className={`col-md-3 col-xs-6 ${isMobile ? 'padding-right-sm' : 'col-sm-6 padding-right-none' }`} data-tip data-for="min-age-tt">
      <FacetDropdown
        placeholder="Min age"
        fieldName="min"
        groupLabel="Age range"
        singleValue={true}
        clearable={false}
        labelKey="label"
        selectedMoreFilter={selectedMinValue}
        changeValueOverride={val => afterChangedValue({ v: [val, ageRange[1]], push, min, max, ageRange, ageRangeFromQS, base })}
        values={minValues} />
    </div>
    <div className={`col-md-3 col-xs-6 ${isMobile ? ' padding-left-none' : 'col-sm-6 padding-right-none' }`} data-tip data-for="max-age-tt">
      <FacetDropdown
        placeholder="Max age"
        fieldName="max"
        groupLabel="&nbsp;"
        singleValue={true}
        clearable={false}
        labelKey="label"
        selectedMoreFilter={selectedMaxValue}
        changeValueOverride={val => afterChangedValue({ v: [ageRange[0], val], push, min, max, ageRange, ageRangeFromQS, base })}
        values={maxValues} />
    </div>
</div>);
};

AgeRange.propTypes = {
  ageRange: PropTypes.array,
  ageRangeFromQS: PropTypes.string,
  isMobile: PropTypes.bool,
  afterChangedValue: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  searchType: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  base: PropTypes.shape({
    pathname: PropTypes.string,
    qs: PropTypes.string
  }).isRequired
};

AgeRange.defaultProps = {
  ageRange: [0, 19],
  min: 0,
  max: 19
};

export const AgeRangeSelect = withRouter(AgeRange);
